import type { IconSvgObject } from './types';

const Structure04Icon: IconSvgObject = [
  ["path", { d: "M10 14V10C10 9.44772 9.55229 9 9 9H3C2.44772 9 2 9.44772 2 10V14C2 14.5523 2.44772 15 3 15H9C9.55229 15 10 14.5523 10 14Z", stroke: "currentColor", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M22 9V5C22 4.44772 21.5523 4 21 4H15C14.4477 4 14 4.44772 14 5V9C14 9.55228 14.4477 10 15 10H21C21.5523 10 22 9.55228 22 9Z", stroke: "currentColor", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }],
  ["path", { d: "M22 19V15C22 14.4477 21.5523 14 21 14H15C14.4477 14 14 14.4477 14 15V19C14 19.5523 14.4477 20 15 20H21C21.5523 20 22 19.5523 22 19Z", stroke: "currentColor", strokeLinejoin: "round", strokeWidth: "1.5", key: "2" }],
  ["path", { d: "M14 7L11 12L14 17", stroke: "currentColor", strokeLinejoin: "round", strokeWidth: "1.5", key: "3" }]
];

export default Structure04Icon;
